import React from 'react';

const SectionCard = ({ children, isDark, className = '' }) => {
    return (
        <div className={`rounded-[10px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] p-[20px] flex flex-col gap-[12px] transition-colors duration-200 ${
            isDark ? 'bg-[#000000]' : 'bg-white'
        } ${className}`}>
            {children}
        </div>
    );
};

export default SectionCard;
